import { ThreePlanogram } from "../../store/types";
import { PlanogramBay } from "@CommonTypes/merchflow/pog/bay";
import { Shelves } from "../Shelves";
import { BayBase } from "./BayBase";
import { BayVerticalLine } from "./BayVerticalLine";

interface Props {
  bay: PlanogramBay;
  bayIndex: number;
  three: ThreePlanogram;
}

export const Bay = ({ bay, bayIndex, three }: Props) => {
  return (
    <>
      <BayBase bay={bay} bayIndex={bayIndex} three={three} />
      <BayVerticalLine bay={bay} bayIndex={bayIndex} three={three} />
      <Shelves shelves={bay.shelves} three={three} />
    </>
  );
};
